import type { AnnexIISerialReferenceValue } from './AppSettings';

const serialSetCache = new WeakMap<string[], Set<string>>();

function getSerialSet(serials: string[]): Set<string> {
  let set = serialSetCache.get(serials);
  if (!set) {
    set = new Set(serials);
    serialSetCache.set(serials, set);
  }
  return set;
}

/**
 * The single, isolated interpreter of the Annex II serial reference.
 * Match is exact only — no prefix/range handling.
 */
export function matchSerialAgainstAnnexII(serial: string, reference: AnnexIISerialReferenceValue[string]): boolean {
  return getSerialSet(reference.serials).has(serial.trim());
}
